import { render, staticRenderFns } from "./fileReader.vue?vue&type=template&id=5bc61228&"
import script from "./fileReader.vue?vue&type=script&lang=js&"
export * from "./fileReader.vue?vue&type=script&lang=js&"
import style0 from "./fileReader.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports